module.exports = __webpack_public_path__ + "static/media/Cecil-icon-01-01-md.22b40c3c.png";